import Utils from 'services/utils';

const VIEW_PLACEMENT_TOP = 'top';
const VIEW_PLACEMENT_DROPDOWN = 'dropdown';

const TOAST_CONFIG = {
    hideDelay: 1500
};

export default class SaveViewPopupController {
    /** @ngInject */
    constructor(ViewsApi, DialogService, searchQuery, onSaveView, EventEmitter, ToastService, CategoriesApi, $q) {
        this.ViewsApi = ViewsApi;
        this.CategoriesApi = CategoriesApi;
        this.DialogService = DialogService;
        this.searchQuery = searchQuery;
        this.eventEmitter = EventEmitter;
        this.onSaveView = onSaveView;
        this.ToastService = ToastService;
        this.$q = $q;

        this.viewPlacement = VIEW_PLACEMENT_TOP;

        this.loadCategories();
    }

    get showDropdown() {
        return this.viewPlacement === VIEW_PLACEMENT_DROPDOWN;
    }

    onCategoryQueryChanged({ query }) {
        this.categoryName = query;
        this.categoryId = null;
    }

    onSearch({ query }) {
        return Utils.searchInIndex(this.searchIndex, query);
    }

    onCategoryFound({ item }) {
        if (item) {
            this.categoryId = item.id;
            this.categoryName = null;
        }
    }

    loadCategories() {
        this.CategoriesApi.getList({
            page_size: 100
        }).then((data) => {
            this.categories = data.categories || [];
            this.searchIndex = Utils.buildSearchIndex(this.categories);
        });
    }

    cancel() {
        this.DialogService.cancel();
    }

    save() {
        if (!this.viewName) {
            return;
        }

        let categoryPromise = {};
        if (this.categoryName) {
            categoryPromise = this.CategoriesApi.createCategory({
                name: this.categoryName
            });
        }

        this.$q.when(categoryPromise).then((category) => {
            const view = {
                name: this.viewName,
                search_query: this.searchQuery,
                category_id: category.id || this.categoryId
            };
            return this.ViewsApi.createView(view);
        }).then((view) => {
            this.onSaveView(
                this.eventEmitter({
                    view
                })
            );
            this.ToastService.showSimpleTranslated('navbar_view_was_created', TOAST_CONFIG);
            this.DialogService.hide();
        }).catch(() => {
            this.ToastService.showSimpleTranslated('navbar_view_wasnt_created', TOAST_CONFIG);
        });
    }
}



// WEBPACK FOOTER //
// ./app/common/save-view/popup/popup.controller.js